import { trpc } from '@/shared/api';

export const usePortfolioCategoriesQuery = () =>
  trpc.portfolio.categories.useQuery(undefined, { retry: false });
